import React from 'react';

function LeadStatusBadge({ status, size = 'md' }) {
  // Appointment-based workflow statuses
  const statusConfig = {
    new: { label: 'NEW', class: 'bg-red-100 text-red-800 border border-red-300' },
    contact_attempted: { label: 'CONTACT ATTEMPTED', class: 'bg-orange-100 text-orange-800 border border-orange-300' },
    contact_made: { label: 'CONTACT MADE', class: 'bg-purple-100 text-purple-800 border border-purple-300' },
    appt_set: { label: 'APPT SET', class: 'bg-green-100 text-green-800 border border-green-300' },
    appt_no_show: { label: 'APPT NO SHOW', class: 'bg-red-100 text-red-800 border border-red-300' },
    appt_held: { label: 'APPT HELD', class: 'bg-teal-100 text-teal-800 border border-teal-300' },
    pending_booking: { label: 'PENDING BOOKING', class: 'bg-orange-100 text-orange-700 border border-orange-300' },
    booked: { label: 'BOOKED', class: 'bg-green-100 text-green-800 border border-green-300 font-semibold' },
    form_submitted: { label: 'FORM SUBMITTED', class: 'bg-emerald-100 text-emerald-900 border border-emerald-400 font-semibold' },
    system_discard: { label: 'SYSTEM DISCARD', class: 'bg-gray-100 text-gray-800 border border-gray-300' },
    manual_discard: { label: 'MANUAL DISCARD', class: 'bg-red-100 text-red-900 border border-red-400' },
    cancel_appointment: { label: 'CANCELLED', class: 'bg-gray-100 text-gray-800 border border-gray-300' }
  };

  const config = statusConfig[status] || { label: status?.toUpperCase() || 'UNKNOWN', class: 'bg-gray-100 text-gray-800 border border-gray-300' };

  // Size variants
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-xs'
  };

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${sizeClasses[size]} ${config.class}`}>
      {config.label}
    </span>
  );
}

export default LeadStatusBadge;
